import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { IAdaptLinkObject } from "@common/route/route.service";
import { EMPTY, lastValueFrom, Observable } from "rxjs";
import { OrganisationsService } from "../organisations.service";

@Component({
    selector: "adapt-link-organisation",
    templateUrl: "./link-organisation.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LinkOrganisationComponent implements OnChanges {
    @Input() public organisation?: Organisation;
    @Input() public organisationId?: number;
    @Input() public selectTab?: string;
    public link$: Observable<IAdaptLinkObject> = EMPTY;

    constructor(
        private organisationService: OrganisationsService,
    ) {
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes.organisation?.currentValue) {
            this.link$ = this.organisationService.getRouteObjToOrganisationDetailPage(changes.organisation.currentValue, this.selectTab);
        } else if (changes.organisationId?.currentValue) {
            this.organisation = await lastValueFrom(this.organisationService.getOrganisationById(changes.organisationId.currentValue));
            this.link$ = this.organisationService.getRouteObjToOrganisationDetailPage(this.organisation!, this.selectTab);
        }
    }
}
